import { render, staticRenderFns } from "./OnboardingStepperSecondEditor.vue?vue&type=template&id=5aa00085&scoped=true&"
import script from "./OnboardingStepperSecondEditor.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepperSecondEditor.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStepperSecondEditor.vue?vue&type=style&index=0&id=5aa00085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa00085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
